module.exports = __webpack_public_path__ + "static/media/lasso.9dc0b4fa.svg";